export default {
  sm: `
  Easy-to-use Console with
  Kind Assistance    
  `,
  lg: `
  Easy-to-use Console
  with Kind Assistance    
  `,
};
